export const enum State {
    Idle = "Idle",
    Busy = "Busy",
    Doomed = "Doomed",
}

export class Registry<Item> {
    private readonly states = new Map<Item, State>();

    public stateOf(item: Item): State {
        this.ensureHas(item);
        // @ts-expect-error item точно есть
        return this.states.get(item);
    }

    public add(item: Item): void {
        if (this.states.has(item)) {
            throw new Error("Registry: duplicate");
        }
        this.states.set(item, State.Idle);
    }

    public capture(item: Item): Item {
        this.expect(item, State.Idle);
        this.states.set(item, State.Busy);
        return item;
    }

    public free(item: Item): void {
        this.expect(item, State.Busy);
        this.states.set(item, State.Idle);
    }

    public doom(item: Item): void {
        this.ensureHas(item);
        this.states.set(item, State.Doomed);
    }

    public remove(item: Item): void {
        if (!this.states.delete(item)) {
            throw new Error("Registry: remove unexpected");
        }
    }

    public findBusy(): Item | undefined {
        return this.states.entries().find(([_, state]) => state === State.Busy)?.[0];
    }

    public doomAll(): Item[] {
        const idles: Item[] = [];
        for (const [item, state] of this.states.entries()) {
            this.states.set(item, State.Doomed);
            if (state === State.Idle) {
                idles.push(item);
            }
        }
        return idles;
    }

    private expect(item: Item, state: State): void {
        this.ensureHas(item);
        if (this.states.get(item) !== state) {
            throw new Error("Registry: unexpected state");
        }
    }

    private ensureHas(item: Item): void {
        if (!this.states.has(item)) {
            throw new Error("Registry: unexpected item");
        }
    }
}
